import { render, staticRenderFns } from "./VuePopup.vue?vue&type=template&id=7acb0c14"
import script from "./VuePopup.vue?vue&type=script&lang=js"
export * from "./VuePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports